import { APIService } from '../services/index'
const pageStore = {
  namespaced: true,
  state: {
    categorie: [],
    forms: [],
    utenti: [],
    settori: [],
    collaboratori: [],
    settoreInfo: [],
    loading: false,
  },
  mutations: {
    SET_CATEGORIE (state, payload) {
      state.categorie = payload
    },
    SET_SETTORI (state, payload) {
      state.settori = payload
    },
    SET_UTENTI (state, payload) {
      state.utenti = payload
    },
    SET_FORMS (state, payload) {
      state.forms = payload
    },
    SET_LOADER (state, payload) {
      state.loading = payload
    },
    SET_COLLABORATORI(state, payload) {
      state.collaboratori = payload
    },
    SET_SETTORE_INFO(state, payload) {
      state.settoreInfo = payload
    },
  },
  actions: {
    getAllUtenti ({ commit }) {
      this.commit('SET_LOADER', true)
      return APIService.SETTINGS.getAllUtenti()
        .then((res) => {
          if (res.stato === 'success') {
            commit('SET_UTENTI', res.data.utenti);
          }
        })
        .catch(res => {
          this._vm.$notify({
            group: 'error',
            text: 'Utenti ' + res.statusText
          })
        })
        .finally(() => {
          this.commit('SET_LOADER', false)
        })
    },
    resetPassword ({ dispatch }, data) {
      return APIService.SETTINGS.resetPassword(data)
    },

  }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/settings.js